import { inject, Injectable } from '@angular/core'
import { ArchivesService } from '@app/generated/api/archives/archives.service'
import type { ArchivesPlacesListParams } from '@app/generated/api/model'

@Injectable({
  providedIn: 'root',
})
export class PlacesApi {
  private readonly archivesService = inject(ArchivesService)

  list (params: ArchivesPlacesListParams) {
    return this.archivesService.places(params)
  }
}
